import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Option, VariableMenuItem, DynamicComponentSelectorService } from '../dynamic-component-selector.service';
import { Observable, ReplaySubject } from 'rxjs';
import { map, shareReplay, switchMap } from 'rxjs/operators';
import { SubstitutionParameter } from '@vendasta/templates';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'email-dynamic-component-dialog',
  templateUrl: './dynamic-component-dialog.component.html',
  styleUrls: ['./dynamic-component-dialog.component.scss'],
})
export class DynamicComponentDialogComponent implements OnInit {
  @Output() formResult: EventEmitter<string | null> = new EventEmitter<string | null>();
  readonly allowedEntryApps = ['RM', 'SM'];

  variables$: Observable<VariableMenuItem[]> = this.dynamicComponentSelectorService
    .getVariables({ includeHtml: true })
    .pipe(
      map((vars) => {
        return vars.filter((v) => {
          return (v?.options?.requiredParams || []).reduce((prev, curr, i, arr) => {
            return prev && !!this[arr[i]];
          }, true);
        });
      }),
      shareReplay(1),
    );

  chosenCategory: VariableMenuItem = null;
  chosenParam: SubstitutionParameter = null;
  chosenParamDetails: string = null;
  chosenDynamicParam$$ = new ReplaySubject<string>(1);
  chosenDynamicParam$: Observable<Option[]>;

  constructor(
    private readonly dynamicComponentSelectorService: DynamicComponentSelectorService,
    public dialogRef: MatDialogRef<DynamicComponentDialogComponent, string | null>,
  ) {}

  ngOnInit(): void {
    this.chosenDynamicParam$ = this.chosenDynamicParam$$.asObservable().pipe(
      switchMap((chosenDynamicParam) => {
        if (
          chosenDynamicParam === 'productName' ||
          chosenDynamicParam === 'productPreviewUrl' ||
          chosenDynamicParam === 'productUrl'
        ) {
          return this.dynamicComponentSelectorService.getProductSubstitutionVariables().pipe(
            map((apps) => {
              if (chosenDynamicParam === 'productUrl') {
                apps = apps.filter((a) => this.allowedEntryApps.includes(a.appId));
              }
              return apps.map((app) => {
                return {
                  title: app.name,
                  value: app.appId,
                };
              });
            }),
          );
        }
      }),
    );
  }

  handleCategoryChange(): void {
    this.chosenParam = null;
    this.chosenParamDetails = null;
  }

  handleParamChange(): void {
    this.chosenParamDetails = null;
    if (
      this.chosenParam.replacementTag === 'productName' ||
      this.chosenParam.replacementTag === 'productPreviewUrl' ||
      this.chosenParam.replacementTag === 'productUrl'
    ) {
      this.chosenDynamicParam$$.next(this.chosenParam.replacementTag);
    }
  }

  add(): void {
    let replacementTag = this.chosenParam.replacementTag;
    if (this.chosenParamDetails) {
      replacementTag = `${replacementTag}['${this.chosenParamDetails}']`;
    }
    this.dialogRef.close('{{ ' + replacementTag + ' }}');
  }

  close(): void {
    this.dialogRef.close(null);
  }
}
